RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const MetricView = widgets.MetricView.extend({
        regions: {
            sparkline: '.x-sparkline-region'
        },
        behaviors: function () {
            const me = this;

            const metric = RivalIQ.metric.build(me.getOption('base'), me.getOption('focus'));
            const information = RivalIQ.metric.render.description(metric);

            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: information
                }
            };
        },

        onAttachLoaded: function () {
            const me = this;
            if (me.spark) {
                const data = _.map(me.spark.getValue({
                    format: false
                }), _.last);
                me.sparkline.show(new RivalIQ.graph.Spark({
                    data: data
                }));
            }
        },

        getName: function () {
            const me = this;
            const metric = me.model;

            let name = metric.get('name');
            if (!name) {
                const nameDimensions = me.getProp('nameDimensions');
                name = RivalIQ.metric.names.metricName(metric.attributes, {
                    dimensions: nameDimensions
                });
            }

            return name;
        },

        serializeData: function () {
            const me = this;

            let submetric;
            const metric = me.model;

            if (me.insight && _.exists(metric.getValue({
                format: false
            }))) {
                submetric = {
                    displayString: [
                        'Rank', me.insight.target.rank, 'of', me.insight.count
                    ].join(' ')
                };
            }

            return {
                metric: {
                    name: me.getName(),
                    value: metric.getValue()
                },
                submetric: submetric,
                submetricDisplayType: me.getProp('submetricDisplayType'),
                deltaMetric: null,
                warnings: {}
            };
        },
        loadData: function () {
            const me = this;

            const base = me.getOption('base');
            const focus = RivalIQ.metric.build(base, me.getOption('focus'));
            const metrics = [focus];

            if (me.getOption('spark')) {
                metrics.push(RivalIQ.metric.build(base, me.getOption('spark')));
            }

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            let secondaryData;
            const secondary = me.getOption('secondary');
            if (secondary) {
                secondaryData = RivalIQ.metric.data.rank(
                    RivalIQ.metric.build(base, secondary), me.getProps());
            }

            return $.when(
                collection.fetch(),
                secondaryData
            ).done(function (collection, rank) {
                me.model = collection.first();
                me.insight = rank;

                if (me.getOption('spark')) {
                    me.spark = collection.last();
                }
            });
        },
        initialize: _.noop
    });

    const Glance = RivalIQ.views.CollectionView.mixin({
        className: 'panel-body',
        childView: MetricView,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'onChange'
        },

        onChange: function () {
            const me = this;
            me.collection = new Backbone.Collection(me.dashboardModel.metrics);
            me.reload();
        },

        childViewOptions: function (model, i) {
            const me = this;
            const dimension = me.dimension;

            let secondary;
            if (me.getProp('insightful') !== false) {
                secondary = _.set({
                    dimensions: [dimension]
                }, me.dimension, undefined);
            }

            return {
                className: 'col-sm-3',
                dashboardModel: me.dashboardModel,
                base: me.dashboardModel.metrics[i],
                focus: {
                    dimensions: [dimension]
                },
                secondary: secondary,
                spark: {
                    dimensions: [dimension, 'day']
                }
            };
        },

        initialize: function () {
            const me = this;
            me.collection = new Backbone.Collection(me.dashboardModel.metrics);
        }
    });

    const GlanceWidget = widgets.ChartWidget.extend({
        getChartTitle: function () {
            const me = this;

            let name;
            if (me.dimension === 'companyId') {
                name = RivalIQ.state.landscape.getCompanyById(me.getProp('companyId')).get('name');
            }

            if (me.dimension === 'presence_id') {
                const presence = me.curation.presence;
                if (presence) {
                    name = (presence.name || presence.handle);
                }
            }

            return _.compact([
                name,
                'at a Glance'
            ]).join(' ');
        },

        viewMore: false,


        getView: function () {
            const me = this;
            return Glance.extend({
                dimension: me.dimension
            });
        },

        processProps: function (props) {
            const me = this;

            if (me.dimension === 'companyId') {
                _.defaults(props, {
                    companyId: props.focusCompanyId
                });
            }

            me.metrics = me.buildMetrics(props);

            return _.defaults(props, {
                nameDimensions: ['channel', 'timeAnalysisMode']
            });
        },

        dimension: 'companyId',

        maxDimensionCount: _.constant(0),

        isSupported: function (props) {
            if (!props.metrics || props.metrics.length > 4) {
                return false;
            }

            if (!_.every(props.metrics, RivalIQ.metric.property.isNumeric)) {
                return false;
            }

            return true;
        },
        propValues: {
            columnWidth: [12],
            timeAnalysisMode: [
                RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE,
                RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
            ]
        },

        // No descriptions for At a Glance
        getSlideDescriptions: _.noop,

        getExportTitle: function () {
            const me = this;
            return RivalIQ.apps.SocialPosts.utils.exportTitle.apply(me, arguments);
        },
        getExportSubtitle: function () {
            const me = this;
            return RivalIQ.apps.SocialPosts.utils.exportSubtitle.apply(me, arguments);
        },
        getPptSubtitle: function () {
            const me = this;
            return RivalIQ.apps.SocialPosts.utils.pptSubtitle.apply(me, arguments);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.GLANCE, GlanceWidget);
});
